package one.healthium.health_advice.domain

import one.healthium.domain.health_log.models.HealthLogModel
import one.healthium.domain.user.UserInteractor

class HealthAdviceInteractor(
    private val healthAdviceRepository: HealthAdviceRepository,
    private val userInteractor: UserInteractor,
) {
    suspend fun getLatestHealthAdviceMessage(): String? {
        val user = userInteractor.getUser()
        val healthLog = user.latestHealthLog
        return healthLog?.let { getHealthAdviceMessage(it) }
    }

    suspend fun getHealthAdviceMessage(healthLog: HealthLogModel): String? {
        val healthAdviceModel = healthAdviceRepository.getRulesSet()

        healthAdviceModel.sets.forEach { rulesSet ->
            val minLevels = rulesSet.minLevels

            val answersWithMinOrHigherLevel = healthLog.answers.filter { entry ->
                entry.answers.any { answer ->
                    answer.weight >= minLevels.minValue && answer.weight <= minLevels.maxValueOrDefault
                }
            }

            if (answersWithMinOrHigherLevel.size >= minLevels.count) {
                val rulesMatchAnswers = rulesSet.rules.filter { rule ->
                    rule.conditions.all { condition ->
                        answersWithMinOrHigherLevel.any { entry ->
                            if (entry.questionId == condition.symptom) {
                                entry.answers.any { answer ->
                                    answer.weight >= condition.value
                                }
                            } else {
                                false
                            }
                        }
                    }
                }

                if (rulesMatchAnswers.isNotEmpty()) {
                    return rulesMatchAnswers.maxByOrRandom { rule ->
                        rule.conditions.sumOf { condition ->
                            condition.value
                        }
                    }?.message
                } else if (!rulesSet.fallbackMessage.isNullOrEmpty()) {
                    return rulesSet.fallbackMessage
                }
            }
        }

        return null
    }
}

private fun <T, R : Comparable<R>> Iterable<T>.maxByOrRandom(selector: (T) -> R): T? {
    val iterator = this.iterator()
    if (!iterator.hasNext()) {
        return null
    }

    val maxElement = iterator.next()
    var maxValue = selector(maxElement)
    val maxElements = mutableListOf(maxElement)

    while (iterator.hasNext()) {
        val currentElement = iterator.next()
        val currentValue = selector(currentElement)

        val comparison = currentValue.compareTo(maxValue)

        if (comparison > 0) {
            maxValue = currentValue
            maxElements.clear()
            maxElements.add(currentElement)
        } else if (comparison == 0) {
            maxElements.add(currentElement)
        }
    }

    return maxElements.random()
}